import { isMobileOnly } from 'react-device-detect';

/** True when the site is opened on a mobile phone (tablets and desktops return false). */
export function isMobilePhone(): boolean {
    return isMobileOnly;
}

/**
 * Interpreters must operate the Connect Streams (CCP) widget from a desktop.
 * When true, the interpreter call/presence/token stack must not run.
 */
export function isInterpreterDesktopRestricted(userType?: string | null): boolean {
    return userType === 'INTERPRETER' && isMobilePhone();
}
